module.exports = __webpack_public_path__ + "img/Icon_Historial_de_Facturas.38f525bc.svg";